import Loading from './Loading';

export default Loading;
export { Loading };
export type { LoadingProps } from './type';
